module.exports = "<div class=\"partial-value-plot\"></div>\n";